import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const modelsApi = {
  // User endpoints
  getAvailableModels: async () => {
    const response = await api.get('/models/available');
    return response.data;
  },

  checkModelAccess: async (modelId: string) => {
    const response = await api.get(`/models/${modelId}/check`);
    return response.data;
  },

  // Admin endpoints
  getAllModels: async (activeOnly: boolean = true) => {
    const response = await api.get('/models', { params: { active_only: activeOnly } });
    return response.data;
  },

  createModel: async (modelData: any) => {
    const response = await api.post('/models', modelData);
    return response.data;
  },

  getModel: async (modelId: string) => {
    const response = await api.get(`/models/${modelId}`);
    return response.data;
  },

  updateModel: async (modelId: string, modelData: any) => {
    const response = await api.put(`/models/${modelId}`, modelData);
    return response.data;
  },

  deleteModel: async (modelId: string) => {
    await api.delete(`/models/${modelId}`);
  },

  // Tier model access endpoints
  getTierModelAccess: async (tierId: string) => {
    const response = await api.get(`/models/tiers/${tierId}/models`);
    return response.data;
  },

  grantTierModelAccess: async (tierId: string, accessData: any) => {
    const response = await api.post(`/models/tiers/${tierId}/models`, accessData);
    return response.data;
  },

  updateTierModelAccess: async (tierId: string, modelId: string, accessData: any) => {
    const response = await api.put(`/models/tiers/${tierId}/models/${modelId}`, accessData);
    return response.data;
  },

  revokeTierModelAccess: async (tierId: string, modelId: string) => {
    await api.delete(`/models/tiers/${tierId}/models/${modelId}`);
  },
};
